module.exports = __webpack_public_path__ + "img/hotdog-top-sra006.7bfd836d.jpg";